var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.57422 14.9646C1.57422 16.3037 2.59819 17.3276 3.93723 17.3276H14.9646C16.3037 17.3276 17.3276 16.3037 17.3276 14.9646V8.66326H1.57422V14.9646ZM14.9646 3.14956H13.3893V2.36189C13.3893 1.88929 13.0742 1.57422 12.6016 1.57422C12.129 1.57422 11.8139 1.88929 11.8139 2.36189V3.14956H7.08792V2.36189C7.08792 1.88929 6.77285 1.57422 6.30025 1.57422C5.82764 1.57422 5.51257 1.88929 5.51257 2.36189V3.14956H3.93723C2.59819 3.14956 1.57422 4.17353 1.57422 5.51257V7.08792H17.3276V5.51257C17.3276 4.17353 16.3037 3.14956 14.9646 3.14956Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.0bf3473d3ce4314c27ec74508e7e4857.svg";
export { ForwardRef as ReactComponent };